module.exports = __webpack_public_path__ + "static/media/account-user.2130f444.svg";